// import * as React from 'react';
// import { useEffect, useMemo, useState } from 'react';
// import { Dialog, DialogContent, Typography } from '@mui/material';
// import { Spin } from 'antd';
// import dayjs from 'dayjs';
// import LeaseDataTable from './LeaseDataTable';
// import solution from 'assets/images/solution_white.svg';
// import ViewEditModalHeader from 'components/modal/ViewEditModalHeader';
//
// function formatNumber(number, decimals = 2) {
// 	// First, handle invalid inputs
// 	if (typeof number !== 'number' || isNaN(number)) {
// 		throw new Error('Please provide a valid number');
// 		// return;
// 	}
//
// 	// Round to specified decimal places using toFixed
// 	// but convert back to number to remove trailing zeros
// 	const roundedNumber = Number(number.toFixed(decimals));
//
// 	// Use Intl.NumberFormat for consistent formatting
// 	const formatter = new Intl.NumberFormat('en-US', {
// 		minimumFractionDigits: decimals,
// 		maximumFractionDigits: decimals,
// 	});
//
// 	return formatter.format(roundedNumber);
// }
// const LeaseRecordViewModal = ({ showModal, setShowModal, checkResponseData = [], tableUpperLeftExtraInfo = null, selectedRow }) => {
// 	// const theme = useTheme();
//
// 	const [processData, setProcessData] = useState(null);
// 	const [showGlData, setShowGlData] = useState(false);
//
// 	useEffect(() => {
// 		let arrayExcludeData = [];
// 		let filteredData = [];
// 		// First, filter out items with group 'Payment'
// 		if (selectedRow > -1) {
// 			filteredData = checkResponseData?.[selectedRow]?.journals?.filter((item) => item?.group !== 'Payment') || [];
// 		}
//
// 		// Process items with cost centers
// 		filteredData.forEach((item) => {
// 			if (item?.glData) {
// 				setShowGlData(true);
// 			}
//
// 			// If item has ccList, create an entry for each cost center
// 			if (item?.ccList && item?.ccList.length > 0) {
// 				item.ccList.forEach((ccItem) => {
// 					// Get cost center code and description - use empty string if not available
// 					const costCenterCode = ccItem.headCode ? ccItem.headCode : '';
// 					const costCenterDescription = ccItem.head ? ccItem.head : '';
// 					const coListCredit = ccItem.credit;
// 					const coListDebit = ccItem.debit;
//
// 					let itemData = {
// 						date: item?.entryDate?.dateString ? dayjs(item?.entryDate?.dateString).format('YYYY-MM-DD') : '',
// 						head: item?.head ? item?.head : '',
// 						description: item?.description ? item?.description : '',
// 						debit: coListDebit,
// 						credit: coListCredit,
// 						costCenterCode: costCenterCode,
// 						costCenterDescription: costCenterDescription,
// 						headCode: item?.headCode ? item?.headCode : '',
// 						glAccount: item?.glData?.generalLedgerCode || '',
// 						glAccountDescription: item?.glData?.generalLegerDescription || '',
// 						headGroup: item?.headGroup ? item?.headGroup : '',
// 					};
//
// 					try {
// 						if (!isNaN(ccItem?.debit) && ccItem?.debit !== null && ccItem?.debit !== undefined) {
// 							itemData.debit = ccItem?.debit ? formatNumber(ccItem?.debit) : ccItem?.debit;
// 						}
// 					} catch (error) {
// 						// Keep default value of 0
// 						itemData.debit = 0;
// 					}
//
// 					try {
// 						if (!isNaN(ccItem?.credit) && ccItem?.credit !== null && ccItem?.credit !== undefined) {
// 							itemData.credit = ccItem?.credit ? formatNumber(ccItem?.credit) : ccItem?.credit;
// 						}
// 					} catch (error) {
// 						// Keep default value of 0
// 						itemData.credit = 0;
// 					}
//
// 					arrayExcludeData.push(itemData);
// 				});
// 			} else {
// 				let itemData = {
// 					date: item?.date,
// 					head: item?.head ? item?.head : '',
// 					description: item?.description ? item?.description : '',
// 					debit: item?.debit ? item?.debit : 0,
// 					credit: item?.credit ? item?.credit : 0,
// 					costCenterCode: '',
// 					costCenterDescription: '',
// 					headCode: item?.headCode ? item?.headCode : '',
// 					glAccount: item?.glData?.generalLedgerCode || '',
// 					glAccountDescription: item?.glData?.generalLegerDescription || '',
// 					headGroup: item?.headGroup ? item?.headGroup : '',
// 				};
//
// 				try {
// 					if (!isNaN(item?.debit) && item?.debit !== null && item?.debit !== undefined) {
// 						itemData.debit = item?.debit ? formatNumber(item?.debit) : item?.debit;
// 					}
// 				} catch (error) {
// 					itemData.debit = 0;
// 					// Keep default value of 0
// 				}
//
// 				try {
// 					if (!isNaN(item?.credit) && item?.credit !== null && item?.credit !== undefined) {
// 						itemData.credit = itemData.credit ? formatNumber(item?.credit) : itemData.credit;
// 					}
// 				} catch (error) {
// 					itemData.credit = 0;
// 					// Keep default value of 0
// 				}
//
// 				arrayExcludeData.push(itemData);
// 			}
// 		});
//
// 		setProcessData(arrayExcludeData);
// 	}, [checkResponseData, tableUpperLeftExtraInfo]);
//
// 	const checkColumnDesign = useMemo(
// 		() => [
// 			{
// 				id: 'date',
// 				width: '5%',
// 				align: 'center',
// 				accessor: 'date',
// 				cellAlign: 'center',
// 				Header: 'Date',
// 				Cell: (cell) => {
// 					const formattedDate = cell?.row?.original?.date ? dayjs(cell.row.original.date).format('YYYY-MM-DD') : '';
// 					return (
// 						<div>
// 							<Typography align="center">{formattedDate}</Typography>
// 						</div>
// 					);
// 				},
// 			},
// 			{
// 				id: 'ccHeadCode',
// 				width: '5%',
// 				align: 'center',
// 				accessor: 'ccHeadCode',
// 				cellAlign: 'left',
// 				Header: 'Cost Center',
// 				isVisible: showGlData,
// 				Cell: (cell) => {
// 					return (
// 						<div style={{ textAlign: 'left' }}>
// 							<Typography>{cell?.row?.original?.costCenterCode}</Typography>
// 						</div>
// 					);
// 				},
// 			},
// 			{
// 				id: 'ccDescription',
// 				width: '5%',
// 				align: 'center',
// 				accessor: 'ccDescription',
// 				cellAlign: 'left',
// 				Header: 'Cost Center Description',
// 				isVisible: showGlData,
// 				Cell: (cell) => {
// 					return (
// 						<div style={{ textAlign: 'left' }}>
// 							<Typography>{cell?.row?.original?.costCenterDescription}</Typography>
// 						</div>
// 					);
// 				},
// 			},
// 			{
// 				id: 'glAccount',
// 				width: '5%',
// 				align: 'center',
// 				accessor: 'glAccount',
// 				cellAlign: 'left',
// 				Header: 'GL Account',
// 				isVisible: showGlData,
// 				Cell: (cell) => {
// 					return (
// 						<div style={{ textAlign: 'left' }}>
// 							<Typography>{cell?.row?.original?.glAccount}</Typography>
// 						</div>
// 					);
// 				},
// 			},
// 			{
// 				id: 'glDescription',
// 				width: '5%',
// 				align: 'center',
// 				accessor: 'glDescription',
// 				cellAlign: 'left',
// 				Header: 'GL Account Description',
// 				isVisible: showGlData,
// 				Cell: (cell) => {
// 					return (
// 						<div style={{ textAlign: 'left' }}>
// 							<Typography>{cell?.row?.original?.glAccountDescription}</Typography>
// 						</div>
// 					);
// 				},
// 			},
// 			{
// 				id: 'leaserHead',
// 				width: '5%',
// 				align: 'center',
// 				accessor: 'leaserHead',
// 				cellAlign: 'left',
// 				Header: 'Lease Heads',
// 				isVisible: !showGlData,
// 				Cell: (cell) => {
// 					return (
// 						<div style={{ textAlign: 'left' }}>
// 							<Typography>{cell?.row?.original?.headGroup}</Typography>
// 						</div>
// 					);
// 				},
// 			},
// 			{
// 				id: 'description',
// 				width: '5%',
// 				align: 'center',
// 				accessor: 'description',
// 				cellAlign: 'left',
// 				Header: 'Description',
// 				Cell: (cell) => {
// 					return (
// 						<div style={{ textAlign: 'left' }}>
// 							<Typography>{cell?.row?.original?.description}</Typography>
// 						</div>
// 					);
// 				},
// 			},
//
// 			{
// 				id: 'debit',
// 				width: '5%',
// 				align: 'center',
// 				accessor: 'debit',
// 				cellAlign: 'center',
// 				Header: 'Debit',
// 				Cell: (cell) => {
// 					return (
// 						<div>
// 							<Typography align="right">{cell?.row?.original?.debit ? cell?.row?.original?.debit : ''}</Typography>
// 						</div>
// 					);
// 				},
// 			},
// 			{
// 				id: 'credit',
// 				width: '5%',
// 				align: 'center',
// 				accessor: 'credit',
// 				cellAlign: 'center',
// 				Header: 'Credit',
// 				Cell: (cell) => {
// 					return (
// 						<div>
// 							<Typography align="right">{cell?.row?.original?.credit ? cell?.row?.original?.credit : ''}</Typography>
// 						</div>
// 					);
// 				},
// 			},
// 		],
// 		[]
// 	);
//
// 	const defaultVisibleColumn = useMemo(() => {
// 		// Return an array of column IDs that should be hidden (where isVisible is false)
// 		return checkColumnDesign.filter((column) => column.isVisible === false).map((column) => column.id);
// 	}, [checkColumnDesign]);
//
// 	const handleClose = () => {
// 		setProcessData(null);
// 		setShowModal(false);
// 	};
//
// 	return (
// 		<Dialog
// 			fullWidth={true}
// 			maxWidth={'lg'}
// 			open={showModal}
// 			keepMounted
// 			onClose={handleClose}
// 			aria-labelledby="draggable-dialog-title"
// 			sx={{ '& .MuiPaper-root': { borderRadius: '8px' } }}
// 		>
// 			<ViewEditModalHeader
// 				headerTitle="Journal Entry"
// 				// type={type}
// 				handleClose={handleClose}
// 				// icon={comptroller}
// 				// screenSize={screenSize}
// 				isScreenSize={false}
// 				// setScreenSize={setScreenSize}
// 				<SolutionCatalogIcon color="#fff" width="20px" height="20px" />
// 			/>
//
// 			<DialogContent sx={{ pb: { xs: 4, md: 7 } }}>
// 				<Spin spinning={processData == null} style={{ maxHeight: '100%', marginTop: '20px' }}>
// 					<LeaseDataTable
// 						xlsxFileName={`${tableUpperLeftExtraInfo?.leaseId}_date`}
// 						firstColStrick={false}
// 						COLUMNS={checkColumnDesign || []}
// 						DATA={processData || []}
// 						pageSize={100}
// 						pagination={false}
// 						onClickHandler={() => {}}
// 						columnFilterSelector={true}
// 						tableUpperLeftExtraInfo={tableUpperLeftExtraInfo}
// 						defaultVisibleColumn={defaultVisibleColumn}
// 					/>
// 				</Spin>
// 			</DialogContent>
// 		</Dialog>
// 	);
// };
// export default LeaseRecordViewModal;
import React, { useMemo } from 'react';
import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import { Spin } from 'antd';
import dayjs from 'dayjs';
import ViewEditModalHeader from '../../../../../components/modal/ViewEditModalHeader';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import LeaseDataTable from './LeaseDataTable';

function formatNumber(number, decimals = 2) {
	if (typeof number !== 'number' || isNaN(number)) {
		// Return an empty string or '0.00' for invalid inputs to avoid breaking the UI
		return '';
	}
	const roundedNumber = Number(number.toFixed(decimals));
	const formatter = new Intl.NumberFormat('en-US', {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	});
	return formatter.format(roundedNumber);
}

const LeaseRecordViewModal = ({ showModal, setShowModal, checkResponseData = [], tableUpperLeftExtraInfo = null, isDataLoading }) => {
	// console.log(checkResponseData,'checkResponseData123');

	// -------------------- CHANGE 1: OPTIMIZED DATA PROCESSING WITH useMemo --------------------
	// Instead of using useEffect to set state, we compute the processed data and the `showGlData` flag directly with useMemo.
	// This makes the data flow more declarative and efficient.
	const { propcessData, showGlData } = useMemo(() => {
		let arrayExcludeData = [];
		let hasGlData = false;

		const filteredData = checkResponseData?.filter((item) => item?.group !== 'Payment') || [];

		filteredData.forEach((item) => {
			if (item?.glData) {
				hasGlData = true;
			}

			if (item?.ccList?.length > 0) {
				item.ccList.forEach((ccItem) => {
					let itemData = {
						date: item?.date ? dayjs(item.date).format('YYYY-MM-DD') : '',
						head: item?.head || '',
						description: item?.description || '',
						debit: '',
						credit: '',
						costCenterCode: ccItem.headCode || '',
						costCenterDescription: ccItem.head || '',
						headCode: item?.headCode || '',
						glAccount: item?.glData?.generalLedgerCode || '',
						glAccountDescription: item?.glData?.generalLegerDescription || '',
						headGroup: item?.headGroup || '',
					};

					if (ccItem?.debit && !isNaN(ccItem.debit)) {
						itemData.debit = formatNumber(ccItem.debit);
					}
					if (ccItem?.credit && !isNaN(ccItem.credit)) {
						itemData.credit = formatNumber(ccItem.credit);
					}
					arrayExcludeData.push(itemData);
				});
			} else {
				let itemData = {
					date: item?.date ? dayjs(item.date).format('YYYY-MM-DD') : '',
					head: item?.head || '',
					description: item?.description || '',
					debit: '',
					credit: '',
					costCenterCode: '',
					costCenterDescription: '',
					headCode: item?.headCode || '',
					glAccount: item?.glData?.generalLedgerCode || '',
					glAccountDescription: item?.glData?.generalLegerDescription || '',
					headGroup: item?.headGroup || '',
				};

				if (item?.debit && !isNaN(item.debit)) {
					itemData.debit = formatNumber(item.debit);
				}
				if (item?.credit && !isNaN(item.credit)) {
					itemData.credit = formatNumber(item.credit);
				}
				arrayExcludeData.push(itemData);
			}
		});

		return { propcessData: arrayExcludeData, showGlData: hasGlData };
	}, [checkResponseData]);

	const checkColumnDesign = useMemo(
		() => [
			// ... (your column definitions remain the same)
			{
				id: 'date',
				width: '5%',
				align: 'center',
				accessor: 'date',
				cellAlign: 'center',
				Header: 'Date',
				Cell: (cell) => (
					<Typography align="center">{cell?.row?.original?.date ? dayjs(cell.row.original.date).format('YYYY-MM-DD') : ''}</Typography>
				),
			},
			{
				id: 'ccHeadCode',
				width: '5%',
				align: 'center',
				accessor: 'ccHeadCode',
				cellAlign: 'left',
				Header: 'Cost Center',
				isVisible: showGlData,
				Cell: (cell) => <Typography>{cell?.row?.original?.costCenterCode}</Typography>,
			},
			{
				id: 'ccDescription',
				width: '5%',
				align: 'center',
				accessor: 'ccDescription',
				cellAlign: 'left',
				Header: 'Cost Center Description',
				isVisible: showGlData,
				Cell: (cell) => <Typography>{cell?.row?.original?.costCenterDescription}</Typography>,
			},
			{
				id: 'glAccount',
				width: '5%',
				align: 'center',
				accessor: 'glAccount',
				cellAlign: 'left',
				Header: 'GL Account',
				isVisible: showGlData,
				Cell: (cell) => <Typography>{cell?.row?.original?.glAccount}</Typography>,
			},
			{
				id: 'glDescription',
				width: '5%',
				align: 'center',
				accessor: 'glDescription',
				cellAlign: 'left',
				Header: 'GL Account Description',
				isVisible: showGlData,
				Cell: (cell) => <Typography>{cell?.row?.original?.glAccountDescription}</Typography>,
			},
			{
				id: 'leaserHead',
				width: '5%',
				align: 'center',
				accessor: 'headGroup',
				cellAlign: 'left',
				Header: 'Lease Heads',
				isVisible: !showGlData,
				Cell: (cell) => <Typography>{cell?.row?.original?.headGroup}</Typography>,
			},
			{
				id: 'description',
				width: '5%',
				align: 'center',
				accessor: 'description',
				cellAlign: 'left',
				Header: 'Description',
				Cell: (cell) => <Typography>{cell?.row?.original?.description}</Typography>,
			},
			{
				id: 'debit',
				width: '5%',
				align: 'center',
				accessor: 'debit',
				cellAlign: 'center',
				Header: 'Debit',
				Cell: (cell) => (
					<Typography align="right">
						{cell?.row?.original?.debit && +cell?.row?.original?.debit !== 0 ? cell?.row?.original?.debit : ''}
					</Typography>
				),
			},
			{
				id: 'credit',
				width: '5%',
				align: 'center',
				accessor: 'credit',
				cellAlign: 'center',
				Header: 'Credit',
				Cell: (cell) => (
					<Typography align="right">
						{cell?.row?.original?.credit && +cell?.row?.original?.credit !== 0 ? cell?.row?.original?.credit : ''}
					</Typography>
				),
			},
		],
		[showGlData] // Dependency is now clearer
	);

	const defaultVisibleColumn = useMemo(() => {
		return checkColumnDesign.filter((column) => column.isVisible === false).map((column) => column.id);
	}, [checkColumnDesign]);

	const handleClose = () => {
		setShowModal(false);
	};

	// -------------------- CHANGE 2: RESTRUCTURED RENDER LOGIC --------------------
	// This single function now handles all three states: loading, empty, and data available.
	const renderContent = () => {
		if (isDataLoading) {
			return (
				<Box display="flex" justifyContent="center" alignItems="center" flexGrow={1}>
					<Spin size="large" tip="Loading..." />
				</Box>
			);
		}

		if (!propcessData || propcessData.length === 0) {
			return (
				<Box display="flex" justifyContent="center" alignItems="center" flexGrow={1} flexDirection="column">
					<Typography variant="h6" color="textSecondary" gutterBottom>
						No Data Available
					</Typography>
					<Typography variant="body2" color="textSecondary">
						There are no journal entries to display.
					</Typography>
				</Box>
			);
		}

		return (
			<LeaseDataTable
				xlsxFileName={`${tableUpperLeftExtraInfo?.leaseId}_date`}
				firstColStrick={false}
				COLUMNS={checkColumnDesign}
				DATA={propcessData}
				pageSize={propcessData.length}
				pagination={false}
				onClickHandler={() => {}}
				columnFilterSelector={true}
				tableUpperLeftExtraInfo={tableUpperLeftExtraInfo}
				defaultVisibleColumn={defaultVisibleColumn}
			/>
		);
	};

	return (
		<React.Fragment>
			<Dialog
				fullWidth={true}
				maxWidth={'lg'}
				open={showModal}
				keepMounted
				onClose={handleClose}
				aria-labelledby="draggable-dialog-title"
				sx={{ '& .MuiPaper-root': { borderRadius: '8px' } }}
			>
				<ViewEditModalHeader
					headerTitle="Journal Entry"
					handleClose={handleClose}
					isScreenSize={false}
					icon={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />}
				/>

				<DialogContent sx={{ pb: { xs: 4, md: 7 } }}>
					{/* -------------------- CHANGE 3: ADDED STABLE CONTAINER -------------------- */}
					{/* This Box provides a stable frame with a minimum height, preventing the modal from resizing. */}
					<Box
						sx={{
							minHeight: '450px', // Adjust this value as needed for your design
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						{renderContent()}
					</Box>
				</DialogContent>
			</Dialog>
		</React.Fragment>
	);
};
export default LeaseRecordViewModal;
